import { SUPPORTED_COUNTRY } from 'utils/constants';

const formatPostalCode = (postalCode?: string, country?: SUPPORTED_COUNTRY) => {
  switch (country?.toUpperCase()) {
    // Combining US and CA since PNA allows these across both sites. The combined
    // formatting should work for both as there are no dashes in the CA postal codes
    case SUPPORTED_COUNTRY.US:
    case SUPPORTED_COUNTRY.CA:
      return postalCode?.split('-')[0]?.toUpperCase();
    default:
      return postalCode;
  }
};

export const formatOrderLookupField = (
  key: string,
  value: string,
  countryCode?: SUPPORTED_COUNTRY
) => {
  switch (key) {
    case 'orderNo':
      return value?.toUpperCase();
    case 'email':
      return value?.toLowerCase();
    case 'postcode':
      if (countryCode) return formatPostalCode(value, countryCode);
      return value;
    default:
      return value;
  }
};
